// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"458ad79f","804":"418e3b4d"}[chunkId] + ".chunk.js";
};